import React, { FC, HTMLAttributes, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { globalVariables } from '../../redux/firestoreGlobalVariables/selector';
import { AdvantagesWrapper } from './SubscriptionAdvantages.style';
import { IonSkeletonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';

interface ISubscriptionAdvantages extends HTMLAttributes<HTMLUListElement> {
  isLoading?: boolean;
  showWeekMessage?: boolean;
}

const SubscriptionAdvantages: FC<ISubscriptionAdvantages> = ({ isLoading, showWeekMessage = true, ...props }) => {
  const intl = useIntl();
  const { t } = useTranslation('subscriptions');

  const globalVars = useSelector(globalVariables);

  const advantagesText = useMemo(
    () => [
      t('subscriptions.subscriptionBenefits.autoRenewal'),
      t('subscriptions.subscriptionBenefits.cancelAnytime'),
      showWeekMessage
        ? t('subscriptions.subscriptionBenefits.reserveSessions', {
            weeks: globalVars.numberOfWeeksForScheduleRendering,
          })
        : null,
      t('subscriptions.subscriptionBenefits.refundPolicy'),
    ],
    [intl?.locale, globalVars.numberOfWeeksForScheduleRendering]
  );

  const getAdvantages = useCallback(() => {
    return advantagesText.map((el) => (el ? <li key={el}>{el}</li> : null));
  }, [advantagesText]);

  if (isLoading) {
    return (
      <AdvantagesWrapper {...props} className={'loading'}>
        {new Array(3).fill('').map((i, index) => (
          <li key={index}>
            <IonSkeletonText
              animated
              style={{
                margin: 0,
                padding: 0,
                width: '30px',
                height: '30px',
                borderRadius: '6px',
              }}
            />
            <IonSkeletonText
              animated
              style={{
                margin: 0,
                padding: 0,
                width: '100%',
                height: index === 1 ? '48px' : '36px',
                borderRadius: '6px',
              }}
            />
          </li>
        ))}
      </AdvantagesWrapper>
    );
  }

  return <AdvantagesWrapper {...props}>{getAdvantages()}</AdvantagesWrapper>;
};

export default SubscriptionAdvantages;
